import {Routes} from "@angular/router";
import {WorkflowCspOneUpgradeSlaComponent} from "./workflow-csp-one-upgrade-sla.component";

export const workflowCspOneUpgradeSlaRouting: Routes = [
    { path: 'csp/upgrade-sla/:aid', component: WorkflowCspOneUpgradeSlaComponent, children: [
            { path: 'address', component: WorkflowCspOneUpgradeSlaComponent },
            { path: 'payment', component: WorkflowCspOneUpgradeSlaComponent },
            { path: 'checkout', component: WorkflowCspOneUpgradeSlaComponent },
            { path: 'complete', component: WorkflowCspOneUpgradeSlaComponent },
            { path: '', redirectTo: 'address', pathMatch: 'full' },
    ]},
]
